import { IIconBase } from '..'

const closeCircleIcon = ({
  color = '#DC3545',
  height = 40,
  width = 41,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 41 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/close-circle'>
        <g id='close-circle'>
          <path
            id='Vector'
            d='M20.4999 36.6666C29.6666 36.6666 37.1666 29.1666 37.1666 20C37.1666 10.8333 29.6666 3.33331 20.4999 3.33331C11.3333 3.33331 3.83325 10.8333 3.83325 20C3.83325 29.1666 11.3333 36.6666 20.4999 36.6666Z'
            stroke={color}
            strokeWidth='2.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M15.7834 24.7167L25.2168 15.2833'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M25.2168 24.7167L15.7834 15.2833'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default closeCircleIcon
